/* KV header (sections/kv-header.liquid): announcement rotation + countdown, desktop dropdown
   focus/touch handling, mobile menu drawer (Impulse theme.Drawers behaviour, vanilla), drawer
   accordions + product slider, country/currency disclosure, cart count bubble. */
(function () {
  if (window.KVHeader) return;
  var html = document.documentElement;
  var desktopMQ = window.matchMedia('(min-width: 769px)');
  var lastPointer = 'mouse';
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

  function whenSwiper(fn) {
    if (window.KV && window.KV.whenSwiper) return window.KV.whenSwiper(fn);
    if (window.Swiper) return fn();
    var n = 0, t = setInterval(function () { if (window.Swiper || ++n > 200) { clearInterval(t); if (window.Swiper) fn(); } }, 50);
  }

  /* ---------- Announcement bar ---------- */
  function initCountdown(el) {
    var target = new Date(el.getAttribute('data-kv-countdown') || '');
    if (isNaN(target) || new Date() >= target) { el.style.display = 'none'; return; }
    var parts = {};
    el.querySelectorAll('[data-kv-cd]').forEach(function (n) { parts[n.getAttribute('data-kv-cd')] = n; });
    var interval;
    function tick() {
      var d = target - Date.now();
      if (d <= 0) { el.style.display = 'none'; clearInterval(interval); return; }
      parts.days.textContent = Math.floor(d / 864e5);
      parts.hours.textContent = Math.floor((d % 864e5) / 36e5);
      parts.minutes.textContent = Math.floor((d % 36e5) / 6e4);
      parts.seconds.textContent = Math.floor((d % 6e4) / 1e3);
    }
    el.style.display = 'flex';
    interval = setInterval(tick, 1000);
    tick();
    return function () { clearInterval(interval); };
  }

  function initOffers(root, cleanups) {
    root.querySelectorAll('[data-kv-countdown]').forEach(function (el) {
      var stop = initCountdown(el);
      if (stop) cleanups.push(stop);
    });
    var rot = root.querySelector('[data-kv-offer-rotator]');
    if (!rot) return;
    var bars = Array.prototype.slice.call(rot.querySelectorAll('[data-kv-offer]'));
    if (bars.length < 2) return;
    var idx = 0, timer = null, paused = false;
    var ms = Math.max(2, parseFloat(rot.getAttribute('data-interval')) || 5) * 1000;
    function show(i) {
      idx = (i + bars.length) % bars.length;
      bars.forEach(function (b, j) {
        b.classList.toggle('is-active', j === idx);
        b.setAttribute('aria-hidden', j === idx ? 'false' : 'true');
        var a = b.querySelector('a');
        if (a) a.tabIndex = j === idx ? 0 : -1;
      });
    }
    function start() { stop(); timer = setInterval(function () { if (!paused) show(idx + 1); }, ms); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    rot.addEventListener('mouseenter', function () { paused = true; });
    rot.addEventListener('mouseleave', function () { paused = false; });
    rot.addEventListener('focusin', function () { paused = true; });
    rot.addEventListener('focusout', function () { paused = false; });
    show(0);
    start();
    function onSelect(e) {
      var i = bars.indexOf(e.target.closest ? e.target.closest('[data-kv-offer]') : null);
      if (i < 0) return;
      stop(); show(i);
    }
    function onDeselect(e) { if (bars.indexOf(e.target) >= 0) start(); }
    document.addEventListener('shopify:block:select', onSelect);
    document.addEventListener('shopify:block:deselect', onDeselect);
    cleanups.push(function () {
      stop();
      document.removeEventListener('shopify:block:select', onSelect);
      document.removeEventListener('shopify:block:deselect', onDeselect);
    });
  }

  /* ---------- Desktop dropdowns (hover is CSS; this adds keyboard + touch) ---------- */
  function initDropdowns(root, cleanups) {
    var items = root.querySelectorAll('.site-nav--has-dropdown');
    function closeAll(except) {
      items.forEach(function (li) { if (li !== except) li.classList.remove('is-focused'); });
    }
    items.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      li.addEventListener('focusin', function () { closeAll(li); li.classList.add('is-focused'); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) li.classList.remove('is-focused');
      });
      li.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) { li.classList.remove('is-focused'); if (link) link.focus(); }
      });
      if (link) {
        var wasOpen = false;
        link.addEventListener('pointerdown', function () { wasOpen = li.classList.contains('is-focused'); });
        link.addEventListener('click', function (e) {
          // Touch: first tap opens the dropdown, second tap follows the link.
          if (lastPointer === 'touch' && !wasOpen) {
            wasOpen = true;
            e.preventDefault();
            closeAll(li);
            li.classList.add('is-focused');
          }
        });
      }
    });
    function onDocClick(e) { if (!e.target.closest || !e.target.closest('.site-nav--has-dropdown')) closeAll(null); }
    document.addEventListener('click', onDocClick);
    cleanups.push(function () { document.removeEventListener('click', onDocClick); });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer(root, cleanups) {
    var drawer = root.querySelector('[data-kv-nav-drawer]');
    if (!drawer) return;
    var siteHeader = root.querySelector('.site-header');
    var overlay = document.getElementById(root.id + '-overlay');
    var buttons = root.querySelectorAll('[data-kv-nav-toggle]');
    var state = { isOpen: false, source: null, closeTimer: null };

    function updateMetrics() {
      if (!siteHeader) return;
      var bottom = Math.round(siteHeader.getBoundingClientRect().bottom);
      drawer.style.setProperty('--kv-drawer-top', bottom + 'px');
      drawer.style.setProperty('--kv-drawer-max-height', Math.max(200, window.innerHeight - bottom) + 'px');
    }
    function setButtons(open) {
      buttons.forEach(function (b) {
        b.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    function prepareTransition(fn) {
      function done(e) { if (e.target !== drawer) return; drawer.classList.remove('is-transitioning'); drawer.removeEventListener('transitionend', done); }
      drawer.addEventListener('transitionend', done);
      drawer.classList.add('is-transitioning');
      void drawer.offsetWidth;
      fn();
      // Safety net if no transition fires.
      setTimeout(function () { drawer.classList.remove('is-transitioning'); }, 600);
    }
    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), select, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function onDocClick(e) {
      if (!state.isOpen) return;
      if (e.target.closest && (e.target.closest('[data-kv-nav-drawer]') || e.target.closest('[data-kv-nav-toggle]'))) return;
      close();
    }
    function open(source) {
      if (state.isOpen) return;
      clearTimeout(state.closeTimer);
      updateMetrics();
      state.isOpen = true;
      state.source = source || null;
      prepareTransition(function () { drawer.classList.add('drawer--is-open'); });
      drawer.setAttribute('aria-hidden', 'false');
      root.classList.add('kv-nav-drawer-active');
      html.classList.add('kv-nav-drawer-open');
      if (overlay) { overlay.classList.remove('is-closing'); overlay.classList.add('is-open'); }
      setButtons(true);
      drawer.setAttribute('tabindex', '-1');
      drawer.focus({ preventScroll: true });
      document.addEventListener('keydown', onKey);
      document.addEventListener('click', onDocClick);
      document.dispatchEvent(new CustomEvent('kv:nav-drawer:open'));
      requestAnimationFrame(updateSwipers);
    }
    function close() {
      if (!state.isOpen) return;
      state.isOpen = false;
      if (drawer.contains(document.activeElement)) document.activeElement.blur();
      prepareTransition(function () { drawer.classList.remove('drawer--is-open'); });
      drawer.setAttribute('aria-hidden', 'true');
      root.classList.remove('kv-nav-drawer-active');
      html.classList.remove('kv-nav-drawer-open');
      if (overlay) {
        overlay.classList.remove('is-open'); overlay.classList.add('is-closing');
        state.closeTimer = setTimeout(function () { overlay.classList.remove('is-closing'); }, 260);
      }
      setButtons(false);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onDocClick);
      if (state.source && document.contains(state.source)) state.source.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('kv:nav-drawer:close'));
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        state.isOpen ? close() : open(btn);
      });
    });
    drawer.querySelectorAll('[data-kv-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    // Close when another drawer/modal opens (Impulse closes drawers on "modalOpen").
    function onOtherOpen() { close(); }
    document.addEventListener('kv:cart:open', onOtherOpen);
    document.addEventListener('modalOpen', onOtherOpen);
    function onResize() { updateMetrics(); if (state.isOpen && desktopMQ.matches) close(); }
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', updateMetrics, { passive: true });
    updateMetrics();

    /* Accordions */
    function setAccordion(acc, shouldOpen) {
      var panel = acc.querySelector('.kv-nav-drawer__accordion-panel');
      var trigger = acc.querySelector('[data-kv-nav-accordion-trigger]');
      if (!panel || !trigger) return;
      if (shouldOpen === acc.classList.contains('is-open')) return;
      if (acc.dataset.kvAccordionAnimating === 'true') return;
      acc.dataset.kvAccordionAnimating = 'true';
      panel.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
      function end(e) {
        if (e && e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', end);
        clearTimeout(safety);
        acc.dataset.kvAccordionAnimating = 'false';
        panel.style.height = shouldOpen ? 'auto' : '0';
        if (shouldOpen) updateSwipers();
      }
      panel.addEventListener('transitionend', end);
      var safety = setTimeout(end, 600);
      if (shouldOpen) {
        acc.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.height = 'auto';
        var h = panel.scrollHeight;
        panel.style.height = '0';
        requestAnimationFrame(function () { panel.style.height = h + 'px'; });
      } else {
        acc.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (panel.style.height === 'auto' || !panel.style.height) panel.style.height = panel.scrollHeight + 'px';
        requestAnimationFrame(function () { requestAnimationFrame(function () { panel.style.height = '0'; }); });
      }
    }
    drawer.querySelectorAll('[data-kv-nav-accordion]').forEach(function (acc) {
      var panel = acc.querySelector('.kv-nav-drawer__accordion-panel');
      var trigger = acc.querySelector('[data-kv-nav-accordion-trigger]');
      if (panel) panel.style.height = acc.classList.contains('is-open') ? 'auto' : '0';
      if (trigger) trigger.addEventListener('click', function () { setAccordion(acc, !acc.classList.contains('is-open')); });
    });

    /* Product slider */
    function updateSwipers() {
      drawer.querySelectorAll('.kv-nav-drawer-products-swiper').forEach(function (el) { if (el.swiper) el.swiper.update(); });
    }
    whenSwiper(function () {
      drawer.querySelectorAll('.kv-nav-drawer-products-swiper').forEach(function (el) {
        if (el.dataset.kvSwiperInit === 'true') return;
        el.dataset.kvSwiperInit = 'true';
        new Swiper(el, {
          slidesPerView: parseFloat(el.getAttribute('data-slides')) || 1.3,
          spaceBetween: 16,
          watchOverflow: true,
          observer: true,
          observeParents: true
        });
      });
    });

    cleanups.push(function () {
      close();
      document.removeEventListener('kv:cart:open', onOtherOpen);
      document.removeEventListener('modalOpen', onOtherOpen);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('scroll', updateMetrics);
      drawer.querySelectorAll('.kv-nav-drawer-products-swiper').forEach(function (el) { if (el.swiper) el.swiper.destroy(true, true); });
    });
    return { open: open, close: close, isOpen: function () { return state.isOpen; } };
  }

  /* ---------- Country / currency disclosure (Impulse theme.Disclosure) ---------- */
  function initDisclosures(root, cleanups) {
    root.querySelectorAll('[data-disclosure-currency], [data-disclosure-locale]').forEach(function (d) {
      var toggle = d.querySelector('[data-disclosure-toggle]');
      var list = d.querySelector('[data-disclosure-list]');
      var input = d.querySelector('[data-disclosure-input]');
      if (!toggle || !list) return;
      function set(open) {
        list.classList.toggle('disclosure-list--visible', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      toggle.addEventListener('click', function (e) { e.stopPropagation(); set(toggle.getAttribute('aria-expanded') !== 'true'); });
      list.querySelectorAll('[data-disclosure-option]').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          if (input) input.value = opt.getAttribute('data-value');
          var form = d.closest('form');
          if (form) form.submit();
        });
      });
      d.addEventListener('keyup', function (e) { if (e.key === 'Escape') { set(false); toggle.focus(); } });
      d.addEventListener('focusout', function (e) { if (e.relatedTarget && !d.contains(e.relatedTarget)) set(false); });
      function onDoc(e) { if (!d.contains(e.target)) set(false); }
      document.addEventListener('click', onDoc);
      cleanups.push(function () { document.removeEventListener('click', onDoc); });
    });
  }

  /* ---------- Cart count bubble ---------- */
  function syncBubble(numEl) {
    var bubble = numEl.closest('.cart-link__bubble');
    if (!bubble) return;
    var n = parseInt(numEl.textContent, 10);
    bubble.classList.toggle('cart-link__bubble--visible', n > 0);
  }
  function setCount(n) {
    n = parseInt(n, 10);
    if (isNaN(n)) return;
    document.querySelectorAll('[data-kv-header] [data-kv-cart-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = String(n);
      syncBubble(el);
    });
  }
  function initCartBubble(root, cleanups) {
    var nums = root.querySelectorAll('[data-kv-cart-count]');
    nums.forEach(syncBubble);
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { nums.forEach(syncBubble); });
    nums.forEach(function (el) { mo.observe(el, { childList: true, characterData: true, subtree: true }); });
    cleanups.push(function () { mo.disconnect(); });
  }
  ['cart:updated', 'kv:cart:updated', 'cart:change', 'ajaxCart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var c = e && e.detail && (e.detail.cart || e.detail);
      if (c && typeof c.item_count !== 'undefined') setCount(c.item_count);
    });
  });
  if (typeof window.KvUpdateCartIconCount !== 'function') window.KvUpdateCartIconCount = setCount;

  /* ---------- Boot ---------- */
  var instances = new Map();
  function init(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    initOffers(root, cleanups);
    initDropdowns(root, cleanups);
    var drawerApi = initDrawer(root, cleanups);
    initDisclosures(root, cleanups);
    initCartBubble(root, cleanups);
    instances.set(root, { cleanups: cleanups, drawer: drawerApi });
  }
  function destroy(root) {
    var inst = instances.get(root);
    if (!inst) return;
    inst.cleanups.forEach(function (fn) { try { fn(); } catch (e) {} });
    instances.delete(root);
  }
  function boot() { document.querySelectorAll('[data-kv-header]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-kv-header]'); if (r) init(r); });
  document.addEventListener('shopify:section:unload', function (e) { var r = e.target.querySelector('[data-kv-header]'); if (r) destroy(r); });

  window.KVHeader = {
    init: init,
    setCartCount: setCount,
    openMenu: function () { instances.forEach(function (i) { if (i.drawer) i.drawer.open(); }); },
    closeMenu: function () { instances.forEach(function (i) { if (i.drawer) i.drawer.close(); }); }
  };
})();
